import { render, staticRenderFns } from "./RoleCategoryPicker.vue?vue&type=template&id=6b835cb8&scoped=true"
import script from "./RoleCategoryPicker.vue?vue&type=script&lang=js"
export * from "./RoleCategoryPicker.vue?vue&type=script&lang=js"
import style0 from "./RoleCategoryPicker.vue?vue&type=style&index=0&id=6b835cb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b835cb8",
  null
  
)

export default component.exports